module.exports = __webpack_public_path__ + "img/prototypefund.623fc69f.png";